import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { CheckCircle } from 'lucide-react'
import api from '../../services/api'
import { useTranslation } from 'react-i18next';

/**
 * Dashboard alert: lists the In-Progress projects the current user (PM/Admin) can close because
 * all milestones are complete and invoiced. Shown on the PM and Admin dashboards so they know
 * to close a finished project. Renders nothing when there's nothing ready.
 */
export default function ReadyToCloseAlert() {
  const { t } = useTranslation('dashboards');
  const navigate = useNavigate()
  const [projects, setProjects] = useState([])

  useEffect(() => {
    let cancelled = false
    api.get('/closure/ready-to-close')
      .then(r => { if (!cancelled) setProjects(r.data?.projects || []) })
      .catch(() => {})
    return () => { cancelled = true }
  }, [])

  if (projects.length === 0) return null

  return (
    <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-5 mb-6">
      <div className="flex items-center gap-2 mb-3">
        <CheckCircle className="w-5 h-5 text-emerald-600" />
        <h3 className="font-semibold text-emerald-900">{t('ready_to_close')}</h3>
      </div>
      <p className="text-sm text-emerald-800 mb-3">
        {projects.length === 1 ? 'This project has' : `${projects.length} projects have`} all milestones
        complete and invoiced — you can close {projects.length === 1 ? 'it' : 'them'} now.
      </p>
      <div className="space-y-2">
        {projects.map(p => (
          <div key={p.id} className="flex items-center justify-between gap-3 bg-white border border-emerald-100 rounded-lg px-3 py-2">
            <div className="min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate">{p.name}</p>
              {p.project_number && <p className="text-[11px] font-mono text-gray-400">{p.project_number}</p>}
            </div>
            <button
              onClick={() => navigate(`/projects/${p.id}`)}
              className="shrink-0 px-4 py-1.5 text-sm font-semibold bg-emerald-600 text-white rounded-lg hover:bg-emerald-700"
            >
              Close it →
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}
